import React, { useEffect, useState } from 'react';
import Link from 'gatsby-link';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

import MobileMenu from './mobileMenu/mobileMenu';
import AlertBanner from '../alertBanner/alertBanner';

import { HeaderBanner, HeaderQuery } from '../../../models/strapi/stateLandingPageQuery';

import * as styles from './header.module.scss';

import { HamburgerMenuOpen, HamburgerMenuClose, Logo } from '../../../assets/svg';

interface PropsType {
    siteTitle: string;
    mobileMenuOpen: boolean;
    toggleMobileMenu: () => void;
    closeAllMenus: () => void;
    data: HeaderQuery;
    usingMouse: boolean;
    setMobileMenu: (bool: boolean) => void;
    alertBannerData: HeaderBanner[];
}

const Header = (props: PropsType) => {
    const [isAlertBarInView, setIsBrandBarInView] = useState<boolean>(true);

    const onScroll = () => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', () => {
                if (window.scrollY >= 30) {
                    setIsBrandBarInView(false);
                } else {
                    setIsBrandBarInView(true);
                }
            });
        }
    };

    useEffect(() => {
        onScroll();
    }, [isAlertBarInView]);
    return (
        <React.Fragment>
            <div
                style={{
                    width: 'inherit'
                }}
                className={styles.flexContainer}
                id='flex-container'>
                <div className={styles.topBar}>
                    {!props.mobileMenuOpen && (
                        <div className={styles.hamburgerIconDiv}>
                            <HamburgerMenuOpen
                                tabIndex={0}
                                onKeyPress={(event: { key: string }) => {
                                    if (event.key === 'Enter') props.toggleMobileMenu();
                                }}
                                aria-hidden='true'
                                onClick={() => {
                                    props.toggleMobileMenu();
                                }}
                                className={props.usingMouse ? 'using-mouse' : ''}
                                title={'Open Mobile Menu'}
                            />
                        </div>
                    )}
                    {props.mobileMenuOpen && (
                        <div className={styles.hamburgerIconDiv}>
                            <HamburgerMenuClose
                                tabIndex={0}
                                onKeyPress={(event: { key: string }) => {
                                    if (event.key === 'Enter') props.toggleMobileMenu();
                                }}
                                onClick={() => {
                                    props.toggleMobileMenu();
                                }}
                                className={props.usingMouse ? 'using-mouse' : ''}
                                title={'Close Mobile Menu'}
                            />
                        </div>
                    )}
                    <div>
                        <MobileMenu
                            usingMouse={props.usingMouse}
                            data={props.data}
                            mobileMenuOpen={props.mobileMenuOpen}
                            toggleMobileMenu={props.toggleMobileMenu}
                            setMobileMenu={props.setMobileMenu}
                        />
                    </div>
                    <Link
                        to={'/'}
                        className={props.usingMouse ? `using-mouse ${styles.logo}` : styles.logo}>
                        <Logo title={'Curaleaf Logo'} aria-hidden='true' />
                    </Link>
                </div>
                <div className={styles.linkBar}>
                    {props.data.menuItem.map((link, i) => (
                        <AnchorLink
                            to={`/#${link.anchorTag}`}
                            className={
                                props.usingMouse
                                    ? `using-mouse ${styles.linkTitle}`
                                    : styles.linkTitle
                            }
                            key={i}>
                            {link.displayText}
                        </AnchorLink>
                    ))}
                </div>
                <div
                    className={
                        !isAlertBarInView
                            ? `${styles.stickyContainer} ${styles.stickyShadow} ${styles.hide}`
                            : `${styles.stickyContainer} ${styles.stickyShadow}`
                    }>
                    <AlertBanner usingMouse={props.usingMouse} data={props.alertBannerData} />
                </div>
            </div>
            <div className={styles.headerHeightBlock} />
        </React.Fragment>
    );
};

export default Header;
